/*
 * Subscribes a profile to a Klaviyo list when a form with
 * [data-klaviyo-list-id] and [data-klaviyo-company-id] is submitted.
 *
 * The native Shopify customer POST navigates away, which:
 *  1. Cancels the Klaviyo request. fetch's keepalive flag is not
 *     dependable here because the custom `revision` header and the
 *     `application/vnd.api+json` content type force a CORS preflight;
 *     the OPTIONS round trip is killed when the page unloads.
 *  2. Redirects the customer off the signup page, so they never see
 *     the form's success message.
 *
 * This script intercepts submit, waits for Klaviyo, then reveals the
 * existing success message in place. It does not replay the Shopify POST.
 *
 * Klaviyo "Create Client Subscription" API revision: 2025-10-15
 * https://developers.klaviyo.com/en/reference/create_client_subscription
 */
(function () {
  var KLAVIYO_API_REVISION = "2025-10-15";

  function fieldValue(form, selector) {
    var input = form.querySelector(selector);
    return input ? input.value.trim() : "";
  }

  function setSubmitting(form, isSubmitting) {
    form.setAttribute("aria-busy", isSubmitting ? "true" : "false");
    var buttons = form.querySelectorAll('[type="submit"]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = isSubmitting;
    }
  }

  function showSuccess(form) {
    var fields = form.querySelector("[data-klaviyo-fields]");
    var success = form.querySelector("[data-klaviyo-success]");
    var error = form.querySelector("[data-klaviyo-error]");

    if (error) error.hidden = true;
    if (fields) fields.hidden = true;
    if (success) {
      success.hidden = false;
      var status = success.querySelector("[data-form-status]");
      if (status && typeof status.focus === "function") status.focus();
    }
  }

  function showError(form) {
    var error = form.querySelector("[data-klaviyo-error]");
    if (!error) return;
    error.hidden = false;
    var status = error.querySelector("[data-form-status]");
    if (status && typeof status.focus === "function") status.focus();
  }

  function subscribeToKlaviyo(companyId, listId, email, firstName, lastName, tag) {
    var profileAttributes = {
      email: email,
      subscriptions: {
        email: {
          marketing: {
            consent: "SUBSCRIBED"
          }
        }
      }
    };

    if (firstName) profileAttributes.first_name = firstName;
    if (lastName) profileAttributes.last_name = lastName;
    if (tag) profileAttributes.properties = { tag: tag };

    var body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Theme signup form",
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    };

    var url = "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId);

    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/vnd.api+json",
        revision: KLAVIYO_API_REVISION
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (response.ok) return true;

        return response.text().then(function (text) {
          console.warn("[klaviyo-signup] subscription rejected", response.status, text);
          return false;
        });
      })
      .catch(function (error) {
        console.warn("[klaviyo-signup] subscription request failed", error);
        return false;
      });
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target.closest("[data-klaviyo-list-id]");
      if (!form) return;

      var companyId = form.dataset.klaviyoCompanyId;
      var listId = form.dataset.klaviyoListId;
      if (!companyId || !listId) return;

      var email = fieldValue(form, 'input[type="email"]');
      if (!email) return;

      event.preventDefault();

      if (form.dataset.klaviyoSubmitting === "true") return;

      form.dataset.klaviyoSubmitting = "true";
      setSubmitting(form, true);

      var firstName = fieldValue(form, 'input[name="contact[first_name]"]');
      var lastName = fieldValue(form, 'input[name="contact[last_name]"]');
      var tag = form.dataset.klaviyoTag ? form.dataset.klaviyoTag.trim() : "";

      subscribeToKlaviyo(companyId, listId, email, firstName, lastName, tag).then(function (ok) {
        if (ok) {
          showSuccess(form);
          return;
        }

        form.dataset.klaviyoSubmitting = "false";
        setSubmitting(form, false);
        showError(form);
      });
    },
    true
  );
})();
